const StatusBadge = ({ status }) => {
  const isActive = Number(status) === 1;

  return (
    <span
      className="d-inline-flex align-items-center justify-content-center"
      style={{
        backgroundColor: isActive ? "#219653" : "#b83227",
        color: "#fff",
        fontSize: "11px",
        fontWeight: 600,
        padding: "4px 14px",
        borderRadius: "999px",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

const getColumns = (handleEdit, handleDelete) => [
  {
    label: "Name",
    field: "name",
    className: "fw-semibold",
    sortable: true,
  },
  {
    label: "Pay Basis",
    field: "pay_basis",
    render: (row) => row.pay_basis || <span className="text-muted">Any</span>,
  },
  {
    label: "Payheads",
    field: "payheads",
    render: (row) => (row.payheads?.length ? row.payheads.map((p) => p.category_name).join(", ") : <span className="text-muted">None</span>),
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => <StatusBadge status={row.status} />,
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleEdit(row)} title="Edit">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div className="cursor-pointer text-danger" onClick={() => handleDelete(row.id)} title="Delete">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;
